import { Injectable } from "@angular/core";

declare const gtag: Function;

@Injectable({
  providedIn: "root",
})
export class GoogleAnalyticsService {
  constructor() {}

  logEvent(eventName: string, params: Record<string, any> = {}): void {
    gtag("event", eventName, params);
  }
}
